import { ACCOUNTANT } from "../types";

export interface Accountant {
  id: string;
  // accountantName: string;
  // accountantDescription: string;
  AccountantName?: string;
  status?: string;
}

const initialState: Accountant = {
  id: "",
  status: "InActive",
  // accountantName: "",
  // accountantDescription: "",
};

export const accountantReducer = (
  state: Accountant = initialState,
  action: any,
): Accountant => {
  switch (action.type) {
    case ACCOUNTANT.ACCOUNTANT_SET_SELECTED:
      return {
        ...state,
        id: action.payload.id,
        // accountantName: action.payload.name,
        // accountantDescription: action.payload.description,
        status: action.payload.status,
      };

    case ACCOUNTANT.ACCOUNTANT_CLEAR_SELECTED:
      return {
        ...state,
        id: "",
        status: "InActive",
        // accountantName: "",
        // accountantDescription: "",
      };
    case ACCOUNTANT.ACCOUNTANT_NAME_SET_SELECTED:
      return {
        ...state,
        // AccountantName: action.payload.fullName,
        AccountantName: action.payload.accTitle,
      };
    case ACCOUNTANT.ACCOUNTANT_NAME_CLEAR_SELECTED:
      return {
        ...state,
        AccountantName: "",
      };

    default:
      return state;
  }
};
